<template>
  <el-table
      :data="requests"
      style="width: 100%">
    <el-table-column
        width="110"
        prop="uuid"
        label="ID" />

    <el-table-column
        width="180"
        prop="device_id"
        label="Device ID" />

    <el-table-column
        width="110"
        prop="type"
        label="type" />

    <el-table-column
        width="110"
        prop="state"
        label="State" />

    <el-table-column
        prop="agent"
        label="Agent" />

    <el-table-column
        width="230"
        prop="created_at"
        label="Date" />

    <el-table-column
        prop="comment"
        label="Comment" />
  </el-table>
</template>

<script>
export default {
  name: "AccessoryOwnRequests",
  props: {
    registries: {
      type: Array,
      required: true,
    },
  },
  computed: {
    timeZone() {
      return this.$store.getters["ui/currentTimezone"];
    },
    requests() {
      return this.registries.map((record) => {
        record.created_at = this.$moment
          .tz(self.created_at, this.timeZone)
          .format("MM/DD/YYYY - hh:mm A Z (z)");
        return record;
      });
    },
  },
  methods: {},
};
</script>

<style scoped></style>
